var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStoreLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.434071 0.375925C0.129434 0.741421 -0.024622 1.20919 0.00320778 1.68418V22.3186C-0.0230473 22.7934 0.130823 23.2606 0.434071 23.6269L0.504575 23.6974L12.0595 12.1346V11.8604L0.504575 0.30542L0.434071 0.375925Z",
    fill: "url(#paint0_linear_348_213)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9138 15.9887L12.0595 12.1344V11.8603L15.9138 8.01379L16 8.0608L20.5672 10.6538C21.8754 11.3902 21.8754 12.6045 20.5672 13.3487L16 15.9417L15.9138 15.9887Z",
    fill: "url(#paint1_linear_348_213)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.9418L12.0831 12.0249L0.434052 23.6268C0.70256 23.8476 1.03686 23.9728 1.38432 23.9827C1.73178 23.9926 2.07268 23.8867 2.35336 23.6817L15.9765 15.9418",
    fill: "url(#paint2_linear_348_213)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.061L2.35336 0.313301C2.07569 0.0998289 1.73253 -0.0106244 1.38248 0.000805904C1.03242 0.0122362 0.697197 0.144841 0.434052 0.375972L12.0595 12.0014L16 8.061Z",
    fill: "url(#paint3_linear_348_213)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.9138 15.8558L2.35338 23.5487C2.08289 23.7502 1.75456 23.8591 1.41723 23.8591C1.0799 23.8591 0.751579 23.7502 0.481085 23.5487L0.41058 23.6192L0.481085 23.6897C0.751579 23.8912 1.0799 24.0001 1.41723 24.0001C1.75456 24.0001 2.08289 23.8912 2.35338 23.6897L15.9765 15.9498L15.9138 15.8558Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M0.434064 23.5015C0.130347 23.1324 -0.0234415 22.6626 0.00325434 22.1854V22.3186C-0.0229975 22.7934 0.130854 23.2606 0.434064 23.6268L0.50456 23.5563L0.434064 23.5015Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M20.5671 13.2077L15.9138 15.8556L16 15.9418L20.5671 13.3174C20.835 13.1996 21.0668 13.0128 21.2389 12.776C21.4109 12.5393 21.517 12.2611 21.5463 11.97C21.4929 12.2391 21.3762 12.4917 21.206 12.7069C21.0357 12.9221 20.8167 13.0938 20.5671 13.2077Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.35337 0.454469L20.5672 10.7873C20.8144 10.8985 21.0319 11.0663 21.202 11.2773C21.3722 11.4883 21.4901 11.7364 21.5464 12.0016C21.5187 11.7099 21.4132 11.431 21.2409 11.194C21.0687 10.957 20.836 10.7706 20.5672 10.6542L2.35337 0.313459C1.06861 -0.422923 0.00320435 0.188118 0.00320435 1.68438V1.81756C0.00320435 0.329127 1.06861 -0.289748 2.35337 0.454469Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_348_213",
    x1: 11.0411,
    y1: 1.46483,
    x2: -4.61878,
    y2: 17.1247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_348_213",
    x1: 20.7239,
    y1: 12.0013,
    x2: -1.85363,
    y2: 12.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_348_213",
    x1: 13.8613,
    y1: 14.14,
    x2: -7.36836,
    y2: 35.3699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_348_213",
    x1: -2.49582,
    y1: -6.49433,
    x2: 6.99099,
    y2: 2.98468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2D9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15BD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06D575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DE76"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreLogo);
export default __webpack_public_path__ + "static/media/play-store-logo.28db8db246b15a3bda9cf1017811f72f.svg";
export { ForwardRef as ReactComponent };